import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';

import { updateInteractionStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

export const useUpdateInteractionStatus = () => {
  const { t } = useTranslation();
  const { updateCache } = useUpdatePatientInfoCache();

  const {
    adminPanelPatients: { updatePatientField },
  } = useDispatch();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateInteractionStatusFn,
    onSuccess(data, variables) {
      if (data) {
        updatePatientField({
          field: 'interactionStatus',
          data: data.interactionStatus,
        });
        updateCache(variables.patientGuid, {
          interactionStatus: data.interactionStatus,
        });
      }

      notificationController.success({
        message: t('responseMessages.interactionStatusUpdate'),
      });
    },
  });

  return {
    updateInteractionStatus: mutateAsync,
    updateInteractionStatusLoading: isLoading,
  };
};
